var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import { SpinnerButton } from './Ui/SpinnerButton/SpinnerButton';
import { appConfigState, appCustomerState, useProgress } from '../Domain/State/AppState';
import { useTrackPageWithCustomDimensions } from '../Tracking';
export function Complete() {
    var _a = useRecoilValue(appConfigState), previousPageUri = _a.previousPageUri, trackingPrefix = _a.trackingPrefix;
    var customerEmail = useRecoilValue(appCustomerState).customerEmail;
    var completeOrder = useProgress().completeOrder;
    var pushInstruction = useMatomo().pushInstruction;
    useEffect(function () {
        completeOrder();
    }, []);
    useEffect(function () {
        pushInstruction('FormAnalytics::trackFormConversion', "".concat(trackingPrefix, "-product-step"));
    }, []);
    useTrackPageWithCustomDimensions();
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "form-page" }, { children: _jsxs("div", __assign({ className: "fields row" }, { children: [_jsxs("div", __assign({ className: "field field--text col col-12 col-md-12" }, { children: [_jsx("label", { children: "Vielen Dank f\u00FCr ihre Bestellung" }), _jsx("div", { className: "field__text" })] })), _jsxs("div", __assign({ className: "field field--text col col-12 col-md-12" }, { children: [_jsx("label", {}), _jsxs("div", __assign({ className: "field__text" }, { children: ["Wir haben eine E-Mail-Best\u00E4tigung an ", customerEmail, " gesendet"] }))] }))] })) })), previousPageUri
                ? _jsx("div", __assign({ className: "actions" }, { children: _jsx("nav", __assign({ className: "form-navigation" }, { children: _jsx("ul", { children: _jsx("li", __assign({ className: "previous" }, { children: _jsx(SpinnerButton, { caption: "zur\u00FCck zur vorherigen Seite", type: "button", clickHandler: function () {
                                        window.location.href = previousPageUri;
                                    }, isDisabled: false, secondary: true }) })) }) })) }))
                : ''] }));
}
